<template>
  <div class="app-modal" v-if="isVisible" >
		<div class="app-modal-wrapper" :style="styleModal">
			<div class="app-modal-header">
				<span class="title-modal">{{ title }}</span>
				<button 
					@click="$emit('close-modal')"
					class="app-modal-close">
					<img 
						src="/static/img/icon-close.svg" alt="Imagen Logo - Close"
						height="24px"
						width="24px">
				</button>
			</div>
			<div class="app-modal-content">
				<slot></slot>
			</div>
		</div>
  </div>
</template>

 <script>
function styleModal() {
	return {
		width: this.width,
		height: this.height,
	};
}
export default {
	name: 'app-modal',
	props: {
		isVisible: {
			default: false,
			type: Boolean,
		},
		title: {
			default: 'Editar',
			type: String,
		},
		width: {
			default: '502px',
			type: String,
		},
		height: {
			default: '604px',
			type: String,
		},
	},
	computed: {
		styleModal,
	},
};

</script>
 <style lang="scss" scoped>
	.app-modal {	
    background-color: rgba(map-get($colors, black), .5);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
		top: 0;
		z-index: 9999;
	}
	
	.app-modal-wrapper {
		@include transform(translate(-50%, -50%));
		background-color: map-get($colors, white);
		box-shadow: 0 0 20px 1px rgba(map-get($colors, black), .8);
		left: 50%;
		overflow-y: scroll;
		position: relative;
		top: 50%;
		width: 40%;
	}

 	.app-modal-header {
		background: map-get($colors, base);
		color: map-get($colors, white);
		padding: 15px 13px;
		position: relative;

 		.title-modal {
			@include font-size(24);
			@include font-maison-bold();
			text-transform: uppercase;
		}
 		.app-modal-close {
			@include transform(translateY(-50%));
			position: absolute;
			right: 13px;
			top: 50%;
		}
	}

 	.app-modal-content {
		height: calc(100% - 66px);
		overflow-y: scroll;
		padding: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/components/commons/app-modal.vue